/*
 * LibertyPaw 2026-09-24: quantity guard (approved by David).
 * - Quantity boxes (cart lines + product page) accept digits only: no ".", "-", "e", "+" or symbols.
 * - Anything typed or pasted after a decimal point is dropped, so "1.5" becomes 1 (not 15).
 * - Maximum 10 per item. Typing more snaps to 10; the + button stops at 10.
 * - After anything is added to the cart (product page, quick buy, Pairs Well With,
 *   cross-sell, toy add-on), any cart line above 10 is brought back to 10.
 * - Stock always wins: if fewer than 10 are in stock, Shopify caps the line at the stock
 *   level and its stock message ("Only 3 items were added...") stays on the line.
 * - The free-gift line is never touched.
 */
(function () {
  if (window.__lpQuantityGuard) return;
  window.__lpQuantityGuard = true;

  var MAX = 10;
  var SELECTOR = 'input[name="updates[]"][data-variant-id], input[name="quantity"]';
  var scriptEl = document.currentScript;
  var MESSAGE = (scriptEl && scriptEl.dataset.maxMessage) || 'Maximum 10 per item.';

  function isGuarded(el) {
    return el && el.matches && el.matches(SELECTOR);
  }

  function applyMax(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (input) {
      if (input.getAttribute('max') !== String(MAX)) input.setAttribute('max', String(MAX));
      if (input.getAttribute('inputmode') !== 'numeric') input.setAttribute('inputmode', 'numeric');
      if (input.getAttribute('pattern') !== '[0-9]*') input.setAttribute('pattern', '[0-9]*');
    });
  }

  function lineOf(input) {
    return input.closest('[data-line-item-key]');
  }

  function showLineMessage(lineEl, text) {
    try {
      var data = window.Alpine && Alpine.$data(lineEl);
      if (data) data.errorMessage = text || MESSAGE;
    } catch (e) {}
  }

  function tellShopper(input) {
    var lineEl = lineOf(input);
    if (lineEl) {
      showLineMessage(lineEl, MESSAGE);
      rememberLineMessage(input.getAttribute('data-variant-id'), MESSAGE);
    } else if (input.reportValidity) {
      input.setCustomValidity(MESSAGE);
      input.reportValidity();
      setTimeout(function () {
        input.setCustomValidity('');
      }, 2500);
    }
  }

  // Whole-number part only: "1.5" -> "1", "2,7" -> "2", "1e5" -> "1".
  function wholePart(text) {
    return String(text || '').split(/[.,eE+\-]/)[0].replace(/[^0-9]/g, '');
  }

  function clamp(input) {
    var digits = wholePart(input.value);
    var next = digits;
    var capped = false;
    if (digits !== '' && Number(digits) > MAX) {
      next = String(MAX);
      capped = true;
    }
    if (next !== input.value) input.value = next;
    if (capped) tellShopper(input);
  }

  // Block anything that is not a digit (keyboard). After a "." or "," the digits that
  // follow are ignored too, so typing 1.5 leaves 1 in the box. Backspace, Delete,
  // arrow keys, select-all, tapping/clicking the box, or leaving it starts fresh, so a
  // shopper who then selects the number and types 3 gets 3.
  document.addEventListener(
    'keydown',
    function (e) {
      var input = e.target;
      if (!isGuarded(input)) return;
      if (e.ctrlKey || e.metaKey || e.altKey) {
        input.__lpAfterDecimal = false;
        return;
      }
      if (e.key === '.' || e.key === ',') {
        e.preventDefault();
        input.__lpAfterDecimal = true;
        return;
      }
      if (e.key && e.key.length === 1) {
        if (!/[0-9]/.test(e.key) || input.__lpAfterDecimal) e.preventDefault();
        return;
      }
      input.__lpAfterDecimal = false;
    },
    true
  );
  ['focus', 'blur', 'pointerdown', 'touchstart', 'mousedown', 'select'].forEach(function (name) {
    document.addEventListener(
      name,
      function (e) {
        if (isGuarded(e.target)) e.target.__lpAfterDecimal = false;
      },
      { capture: true, passive: true }
    );
  });

  // Paste / drop: keep digits only.
  document.addEventListener(
    'paste',
    function (e) {
      if (!isGuarded(e.target)) return;
      var text = (e.clipboardData || window.clipboardData).getData('text') || '';
      e.preventDefault();
      e.target.value = wholePart(text);
      clamp(e.target);
      e.target.dispatchEvent(new Event('input', { bubbles: true }));
    },
    true
  );

  document.addEventListener(
    'drop',
    function (e) {
      if (isGuarded(e.target)) e.preventDefault();
    },
    true
  );

  // Clamp before the theme reads the value (capture phase runs first).
  document.addEventListener(
    'input',
    function (e) {
      if (isGuarded(e.target)) clamp(e.target);
    },
    true
  );
  document.addEventListener(
    'change',
    function (e) {
      if (isGuarded(e.target)) clamp(e.target);
    },
    true
  );

  // Keep the max attribute on boxes that are re-rendered (cart morphs, quick buy).
  applyMax();
  var applyQueued = false;
  new MutationObserver(function () {
    if (applyQueued) return;
    applyQueued = true;
    requestAnimationFrame(function () {
      applyQueued = false;
      applyMax();
      if (Object.keys(stickyMessages).length) applyStickyMessages();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Messages stay attached to a cart line for a few seconds, because the theme clears
  // line messages while it updates the cart. They are re-applied whenever the cart
  // re-renders and on a few timed checks, then left alone. They are keyed by variant,
  // because Shopify gives a cart line a new key when its quantity changes.
  var stickyMessages = {};
  function applyStickyMessages() {
    var now = Date.now();
    Object.keys(stickyMessages).forEach(function (variantId) {
      var entry = stickyMessages[variantId];
      if (entry.until < now) {
        delete stickyMessages[variantId];
        return;
      }
      // The cart can be on the page twice (drawer + /cart page), so update every copy.
      document.querySelectorAll('input[name="updates[]"][data-variant-id="' + variantId + '"]').forEach(function (input) {
        var lineEl = lineOf(input);
        if (!lineEl) return;
        try {
          var data = window.Alpine && Alpine.$data(lineEl);
          if (data && !data.errorMessage) data.errorMessage = entry.text;
        } catch (e) {}
      });
    });
  }
  function rememberLineMessage(variantId, text) {
    if (!variantId || !text) return;
    stickyMessages[String(variantId)] = { text: text, until: Date.now() + 5000 };
    [0, 300, 800, 1500, 3000, 4800].forEach(function (ms) {
      setTimeout(applyStickyMessages, ms);
    });
  }
  // Stock limit (or any Shopify error) on a cart line: keep Shopify's message on the
  // line after the cart refreshes to the quantity actually in stock.
  document.addEventListener('theme:line-item:error', function (e) {
    var d = e.detail || {};
    rememberLineMessage(d.variantId, d.message);
  });
  ['theme:line-item:change', 'theme:cart:update'].forEach(function (name) {
    document.addEventListener(name, function () {
      setTimeout(applyStickyMessages, 0);
    });
  });

  // Cart-wide check: bring any line above 10 back to 10.
  var checking = false;
  var recheck = false;
  function isGift(item) {
    return (item.properties && item.properties._free_gift) || item.handle === 'free-water-drop-tug';
  }
  async function enforceCart() {
    if (checking) {
      recheck = true;
      return;
    }
    checking = true;
    try {
      var cart = await fetch((window.theme && theme.routes && theme.routes.cart_url ? theme.routes.cart_url : '/cart') + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) {
        return r.json();
      });
      var over = (cart.items || []).filter(function (item) {
        return !isGift(item) && item.quantity > MAX;
      });
      if (!over.length) return;
      for (var i = 0; i < over.length; i++) {
        await fetch((window.theme && theme.routes && theme.routes.cart_change_url) || '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: over[i].key, quantity: MAX })
        });
        rememberLineMessage(over[i].variant_id, MESSAGE);
      }
      document.dispatchEvent(new CustomEvent('theme:update:cart'));
    } catch (e) {
      console.error(e);
    } finally {
      checking = false;
      if (recheck) {
        recheck = false;
        enforceCart();
      }
    }
  }
  ['shapes:cart:afteradditem', 'shapes:cart:cartqtychange', 'shapes:cart:update'].forEach(function (name) {
    window.addEventListener(name, function () {
      enforceCart();
    });
  });
  document.addEventListener('theme:product:add', function () {
    enforceCart();
  });
  enforceCart();
})();
